/**
 * Organization roles (Firestore `users/{uid}.role`).
 * Same tier as Settings company-profile editors and integration Cloud Functions (`owner` | `admin` | `superuser`).
 */
const ORG_PROFILE_ADMIN_ROLES = new Set(['owner', 'admin', 'superuser']);

export function normalizeUserRole(role) {
  const r = String(role ?? 'member').trim().toLowerCase();
  return r || 'member';
}

/** Who may edit company profile fields under Settings (names, addresses, logo, blocklist, etc.). */
export function canEditOrganizationProfile(role) {
  return ORG_PROFILE_ADMIN_ROLES.has(normalizeUserRole(role));
}

/** Who may open Integrations (sidebar + route); aligns with integration Cloud Functions. */
export function canAccessIntegrations(role) {
  return ORG_PROFILE_ADMIN_ROLES.has(normalizeUserRole(role));
}

/** Who may edit screening notification emails under Settings. */
export function canEditScreeningNotifications(role) {
  return ORG_PROFILE_ADMIN_ROLES.has(normalizeUserRole(role));
}
